import { createAsyncThunk } from '@reduxjs/toolkit';
import { IConfigApiResponse } from '..';
import { httpService } from '../../..';
import { ApiUrls } from '../../ApiUrls';
import { executeApiRequest } from '../../asyncUtils';

export const fetchConfigThunk = createAsyncThunk(
  'config/fetch',
  async (section: keyof IConfigApiResponse | undefined = undefined, { rejectWithValue }) => {
    const response = await executeApiRequest<IConfigApiResponse>(() => httpService.get(ApiUrls.config(section)));
    if (response.requestFailed) {
      return rejectWithValue(`Failed to fetch config section ${section}`);
    }

    return response.value;
  }
);
